import { getModalPopupScriptPath } from '@shared/getScriptPath';
import { consoleLogger } from '@shared/logging/consoleLogger';

/**
 * Creates and executes modal popup script on the page (if doesn't exist), or shows the modal popup if is already created
 *
 * @param utiqHost - Utiq domain URL, which will become the source of the script (for non-local environments)
 * @returns undefined
 *
 */
export const handleModalPopup = () => {
  if (
    document.getElementById('utiq__modal-popup') &&
    typeof window.Utiq?.API?.showConsentModal == 'function'
  ) {
    consoleLogger.logDebug(
      'Utiq modal popup is already loaded on the page. Proceeding...',
    );
  } else {
    const utiqmodalPopup = document.createElement('script');
    utiqmodalPopup.setAttribute('id', 'utiq__modal-popup');
    utiqmodalPopup.src = getModalPopupScriptPath();
    document.head.appendChild(utiqmodalPopup);
    consoleLogger.logDebug('Modal popup appended to the document head');
  }
};
